define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var i18n = require('i18n');
    var validationHelpers = require('modules/user/user.validation.helpers');

    var validatePhoneNumber = function(isPhoneRequired, $inputs) {
        var originPhoneValue = $inputs.map(_.property('value')).join('').trim();
        var phone = originPhoneValue.replace(/\+/g, '');
        var area = _.find($inputs, function(input) {
            return input.name === 'cellphone_area';
        });
        var areaValue;

        if (area) {
            areaValue = area.value.trim().replace(/\+/g, '');
            if (areaValue.length < 1 || areaValue.length > 4) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.area.length');
                return false;
            }
        }

        if (isPhoneRequired && !phone) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.required');
            return false;
        }

        if (isPhoneRequired && (phone.length < 7 || phone.length > 15)) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.length');
            return false;
        }

        return /^\+?[0-9]+$/.test(originPhoneValue);
    };

    module.exports = {
        ...validationHelpers,
        validatePhoneNumber
    };
});
